import { callAPI } from "@/api/httpservice";
import {
  type DisciplineAndCountryResponse,
  type StatsFilter,
  type errorsStat,
  type numberedStat,
  type objectByStatus,
} from "@/types/stats.types";

export function searchParams(filter: StatsFilter) {
  const params = new URLSearchParams();
  if (filter.country) params.append("countryCode", filter.country);
  if (filter.discipline) params.append("disciplineCode", filter.discipline);
  if (filter.fileStatus) params.append("fileStatus", filter.fileStatus);
  if (filter.envelopeStatus) params.append("envelopeStatus", filter.envelopeStatus);
  if (filter.site) params.append("siteId", filter.site);
  if (filter.kit) params.append("kitId", filter.kit);
  if (filter.cluster) params.append("clusterId", filter.cluster);
  if (filter.processType) params.append("processType", filter.processType);
  if (filter.timeAgo) params.append("timeAgo", filter.timeAgo);
  return params;
}

export function apiFetchEnvelopesTotal(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/envelopes?${params.toString()}`;
  return callAPI<number>("GET", url);
}
export function apiFetchErrorsTotal(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/errors?${params.toString()}`;
  return callAPI<errorsStat>("GET", url);
}
export function apiFetchFilesTotal(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/files?${params.toString()}`;

  return callAPI<number>("GET", url);
}

export function apiFetchEnvelopeTotalByStatus(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/envelopes/by-Status?${params.toString()}`;

  return callAPI<objectByStatus>("GET", url);
}

export function apiFetchFilesTotalByStatus(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/files/by-status?${params.toString()}`;

  return callAPI<objectByStatus>("GET", url);
}
export function apiFetchFilesTotalByDescription(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/files/by-description?${params.toString()}`;

  return callAPI<objectByStatus>("GET", url);
}

export function apiFetchAthletesTotalByDiscipline(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/files/by-discipline?${params.toString()}`;
  return callAPI<objectByStatus>("GET", url);
}

export function apiFetchErrorsTotalByStatus(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/errors/by-status?${params.toString()}`;
  return callAPI<objectByStatus>("GET", url);
}

export function apiFetchErrorsResolutionTime() {
  return callAPI<numberedStat>("GET", `/stats/errors/resolution-time`);
}

export function apiAverageProcessTime() {
  return callAPI<string>("GET", `/stats/process-time`);
}

export function apiFetchDisciplinesAndCountries() {
  return callAPI<DisciplineAndCountryResponse>(
    "GET",
    `/stats/disciplineAndCountry`
  );
}

export function apiFetchFileByProcessType(filter: StatsFilter) {
  const params = searchParams(filter);
  const url = `/stats/process-type?${params.toString()}`;
  return callAPI<objectByStatus>("GET", url);
}
